/* Keep the transparent hero header aligned when fonts or responsive rows change height. */
(() => {
  let observer;
  const bindHeader = () => {
    const header = document.querySelector('body.allsum-home-unified .section-header');
    const wrapper = header?.querySelector('.header-wrapper');
    if (!header || !wrapper) return;
    if (observer) observer.disconnect();
    const measure = () => {
      // Measure the content, not the grid item stretched by its own negative margin.
      const height = `${wrapper.offsetHeight}px`;
      document.documentElement.style.setProperty('--home-header-height', height);
      document.documentElement.style.setProperty('--header-height', height);
    };
    measure();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(measure);
      observer.observe(wrapper);
    }
  };
  bindHeader();
  document.addEventListener('shopify:section:load', bindHeader);
  let previousScroll = window.scrollY;
  const closeMenus = () => {
    const header = document.querySelector('body.allsum-home-unified .header-wrapper');
    if (!header) return;
    header.querySelectorAll('.header__inline-menu details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
    header.preventHide = false;
    document.documentElement.classList.remove('exbrite-mega-menu-open');
  };
  window.addEventListener('scroll', () => {
    if (Math.abs(window.scrollY - previousScroll) > 4) closeMenus();
    previousScroll = window.scrollY;
  }, {passive: true, capture: true});
  window.addEventListener('resize', closeMenus, {passive: true});
})();
